import { render, staticRenderFns } from "./evaluations-form.vue?vue&type=template&id=f82b6550&"
import script from "./evaluations-form.vue?vue&type=script&lang=js&"
export * from "./evaluations-form.vue?vue&type=script&lang=js&"
import style0 from "./evaluations-form.vue?vue&type=style&index=0&id=f82b6550&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports